import Api from '../../../../../../Api';
import { IPagedRequest } from '../../../../../../shared-interfaces/IPagedRequest';
import { IPagedResponse } from '../../../../../../shared-interfaces/IPagedResponse';
import { ICoreUser } from '../../../../../../shared-interfaces/User/ICoreUser';

export interface IGetAdvisors {
  userId: string;
  term?: string;
}

const ConnectionsService = {
  getAdvisors: async (
    request: IPagedRequest<IGetAdvisors>,
  ): Promise<IPagedResponse<ICoreUser>> => {
    const response = await Api.post(
      `user/connections/GetAdvisors/${request.searchParameters.userId}`,
      request,
    );
    if (response.status != 200) throw response.status;
    return response.data;
  },
  getAdvisees: async (
    request: IPagedRequest<IGetAdvisors>,
  ): Promise<IPagedResponse<ICoreUser>> => {
    const response = await Api.post(
      `user/connections/GetAdvisees/${request.searchParameters.userId}`,
      request,
    );
    if (response.status != 200) throw response.status;
    return response.data;
  },
  deleteAdvisorConnection: async (
    userId: string,
    selectedUserId: string,
    userIdsToDelete: string[],
  ): Promise<void> => {
    const response = await Api.delete(
      `user/connections/DeleteAdvisorConnections/${userId}?studentId=${selectedUserId}&advisorIds=${userIdsToDelete}`,
    );
    if (response.status != 200) throw response.status;
  },
  addAdvisorConnections: async (
    userId: string,
    studentId: string,
    advisorIds: string[],
  ): Promise<void> => {
    const response = await Api.post(
      `user/connections/AddAdvisorConnections/${userId}`,
      {
        studentId: studentId,
        advisorIds: advisorIds,
      },
    );
    if (response.status != 200) throw response.status;
  },
};

export default ConnectionsService;
